import { pageHead } from "@/lib/routeHead";
import { createFileRoute } from "@tanstack/react-router";
import EmployeeTimesheetsPage from "@/pages/employee/EmployeeTimesheetsPage";

export const Route = createFileRoute("/employee/timesheets")({
  head: () => pageHead("Employee · Timesheets", "AKIVA employee · timesheets portal.", "/employee/timesheets", true),
  component: EmployeeTimesheetsPage,
});
